import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_card_title = _resolveComponent("ion-card-title")!
  const _component_ion_card_subtitle = _resolveComponent("ion-card-subtitle")!
  const _component_ion_card_header = _resolveComponent("ion-card-header")!
  const _component_add_remove_multiple_items = _resolveComponent("add-remove-multiple-items")!
  const _component_ion_card_content = _resolveComponent("ion-card-content")!
  const _component_ion_card = _resolveComponent("ion-card")!

  return (_openBlock(), _createBlock(_component_ion_card, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_card_header, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_card_title, null, {
            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
              _createTextVNode(" Notes ", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_ion_card_subtitle, { class: "tips" }, {
            default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
              _createElementVNode("span", { class: "material-icons" }, " tips_and_updates ", -1),
              _createElementVNode("span", { class: "info" }, " It can be a ninja technique to memorize the meaning, a personal relatable incident, etc. ", -1)
            ]))]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_card_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_add_remove_multiple_items, {
            ref: "AddRemoveMultipleItemsRef",
            "existing-items": _ctx.existingNotes,
            "item-class": 'vocab-upsert-item'
          }, null, 8, ["existing-items"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}